import Iframe from '../components/helpers/Iframe';
import MessagesSidebarWrapper from '@desktop/components/messages/SidebarWrapper';
import RecordStateOverview from '@components/record/state/StateOverview';
import {
    BAlert,
    BBadge,
    BButton,
    BButtonGroup,
    BCard,
    BCardBody,
    BCardFooter,
    BCardHeader,
    BCardText,
    BCol,
    BCollapse,
    BForm,
    BFormCheckbox,
    BFormCheckboxGroup,
    BFormGroup,
    BFormInput,
    BFormRadio,
    BFormRadioGroup,
    BFormSelect,
    BFormSelectOption,
    BFormTextarea,
    BImg,
    BInputGroup,
    BInputGroupAppend,
    BLink,
    BPagination,
    BPopover,
    BProgress,
    BSpinner,
    BTab,
    BTabs,
    BTable,
    BTableSimple,
    BTd,
    BTr,
    BRow
} from 'bootstrap-vue/src';
import FormGroupBtnSubmit from '@components/form/FormGroupBtnSubmit';
import FormGroupInput from '@components/form/FormGroupInput';
import AdminUserSelect from '@components/AdminUserSelect.vue';
import FormGroupOptionalBoolean from '@components/form/FormGroupOptionalBoolean';
import StripedBlockWithHeader from '@components/StripedBlockWithHeader';
import FormGroupTextarea from '@components/form/FormGroupTextarea';
import FormGroupSelectSearchable from '@components/form/FormGroupSelectSearchable';
import FormGroupSelectSearchableWithTags from '@components/form/FormGroupSelectSearchableWithTags';
import FormGroupRadio from '@components/form/FormGroupRadio';
import FormGroupSelect from '@components/form/FormGroupSelect';
import FlashMessenger from '@desktop/components/helpers/FlashMessenger';
import RecordTableRow from '@desktop/components/record/list/RecordTableRow';
import RecordTableFirmNameWithTooltip from '@desktop/components/record/list/RecordTableFirmNameWithTooltip';
import RecordTableReferenceNumberWithHint from '@desktop/components/record/list/RecordTableReferenceNumberWithHint';
import FormGroupCheckbox from '@components/form/FormGroupCheckbox';
import FormGroupCheckboxGroup from '@components/form/FormGroupCheckboxGroup';
import LoadingIndicator from '@components/LoadingIndicator';
import FoldableBase from '@components/foldable/Base.vue';
import HideForGroup from '@components/record/detail/HideForGroup';
import CspCkeditor from '@components/ckeditor/CkEditor.vue';
import CspCkeditorReduced from '@components/ckeditor/CkEditorReduced.vue';
import FormGroupCkeditor from '@components/form/FormGroupCkeditor';
import FormGroupCkeditorReduced from '@components/form/FormGroupCkeditorReduced';
import FormGroupSelectInsurancePolicyParent from '@csp-app/components/formgroup/SelectInsurancePolicyParent.vue';
import RecordCustomerVehicleInfo from '@csp-app/components/record/CustomerVehicleInfo.vue';
import MicroportalItem from '@components/MicroportalItem.vue';
import RetroactiveChangesModal from '@desktop/components/record/RetroactiveChangesModal.vue';

export default {
    'b-alert': BAlert,
    'b-badge': BBadge,
    'b-button': BButton,
    'b-button-group': BButtonGroup,
    'b-card': BCard,
    'b-card-body': BCardBody,
    'b-card-footer': BCardFooter,
    'b-card-header': BCardHeader,
    'b-card-text': BCardText,
    'b-col': BCol,
    'b-collapse': BCollapse,
    'b-form': BForm,
    'b-form-checkbox': BFormCheckbox,
    'b-form-checkbox-group': BFormCheckboxGroup,
    'b-form-group': BFormGroup,
    'b-form-input': BFormInput,
    'b-input': BFormInput,
    'b-input-group': BInputGroup,
    'b-input-group-append': BInputGroupAppend,
    'b-form-radio-group': BFormRadioGroup,
    'b-form-radio': BFormRadio,
    'b-form-select': BFormSelect,
    'b-form-select-option': BFormSelectOption,
    'b-form-textarea': BFormTextarea,
    'b-img': BImg,
    'b-link': BLink,
    'b-pagination': BPagination,
    'b-row': BRow,
    'b-tab': BTab,
    'b-tabs': BTabs,
    'b-table': BTable,
    'b-table-simple': BTableSimple,
    'b-td': BTd,
    'b-tr': BTr,
    'b-popover': BPopover,
    'b-progress': BProgress,
    'b-spinner': BSpinner,

    // Customized Bootstrap Vue components
    'b-modal': () => import(/* webpackChunkName: "desktop/components/popup/modal" */ '@desktop/components/popup/Modal'),

    // Global components
    'csp-popover': () => import(/* webpackChunkName: "components/popover" */ '@components/Popover'),
    'csp-admin-user-select': AdminUserSelect,
    'csp-flash-messenger': FlashMessenger,
    'csp-form-group-checkbox': FormGroupCheckbox,
    'csp-form-group-checkbox-group': FormGroupCheckboxGroup,
    'csp-form-group-btn-submit': FormGroupBtnSubmit,
    'csp-form-group-datepicker': () => import(/* webpackChunkName: "components/form/form-group-datepicker" */ '@components/form/FormGroupDatePicker'),
    'csp-form-group-input': FormGroupInput,
    'csp-form-group-input-currency' : () => import(/* webpackChunkName: "components/form/form-group-input-currency" */ '@components/form/FormGroupInputCurrency'),
    'csp-form-group-optional-bool': FormGroupOptionalBoolean,
    'csp-form-group-radio': FormGroupRadio,
    'csp-form-group-select': FormGroupSelect,
    'csp-form-group-select-searchable': FormGroupSelectSearchable,
    'csp-form-group-select-searchable-with-tags': FormGroupSelectSearchableWithTags,
    'csp-form-group-textarea': FormGroupTextarea,
    'csp-form-group-ckeditor': FormGroupCkeditor,
    'csp-form-group-ckeditor-reduced': FormGroupCkeditorReduced,
    'csp-form-tooltip': () => import('@components/form/FormTooltip.vue'),
    'csp-base-file-upload': () => import(/* webpackChunkName: "components/file/file-upload-base" */ '@components/file/BaseFileUpload'),
    'csp-striped-block': StripedBlockWithHeader,
    'csp-analytics-bar-chart': () => import(/* webpackChunkName: "components/analytics/analytics-bar-chart" */ '@components/analytics/AnalyticsBarChart'),
    'csp-loading-indicator': LoadingIndicator,
    'csp-file-gallery': () => import('@components/file/Gallery.vue'),
    'csp-hide-for-group': HideForGroup,
    'csp-ckeditor': CspCkeditor,
    'csp-ckeditor-reduced': CspCkeditorReduced,
    'csp-context-menu': () => import(/* webpackChunkName: "components/context-menu" */ '@components/ContextMenu.vue'),
    'csp-cropped-image-upload': () => import(/* webpackChunkName: "components/file/cropped-image-upload" */ '@components/file/CroppedImageUpload'),
    'csp-microportal-item': MicroportalItem,

    // Desktop components
    'csp-firm-branch-select': () => import('@desktop/components/user/FirmBranchSelect.vue'),
    'csp-firm-files': () => import(/* webpackChunkName: "desktop/components/firm/firmfiles" */ '@desktop/components/firm/FirmFiles'),
    'csp-firm-documents': () => import(/* webpackChunkName: "desktop/components/firm/firm-documents" */ '@desktop/components/firm/FirmDocuments'),
    'csp-firm-document-upload': () => import(/* webpackChunkName: "desktop/components/firm/firm-document-upload" */ '@desktop/components/firm/FirmDocumentUpload'),
    'csp-changelog-modal': () => import(/* webpackChunkName: "desktop/components/helpers/Changelog" */ '@desktop/components/helpers/Changelog'),
    'csp-record-state-change': () => import(/* webpackChunkName: "desktop/components/record/RecordStateChange.vue" */ '@desktop/components/record/RecordStateChange.vue'),
    'csp-iframe': Iframe,
    'csp-messages-sidebar': () => import(/* webpackChunkName: "desktop/components/messages/sidebar" */ '@desktop/components/messages/Sidebar'),
    'csp-messages-sidebar-wrapper': MessagesSidebarWrapper,
    'csp-popup-display': () => import(/* webpackChunkName: "desktop/components/popup/popup-display" */ '@desktop/components/popup/PopupDisplay'),
    'csp-record-state-overview': RecordStateOverview,
    'csp-formelement-multiselectsearchable': () => import(/* webpackChunkName: "desktop/components/formelements/multiselect-searchable" */ '@desktop/components/formelements/MultiSelectSearchable'),
    'csp-formelement-treeselectmultiple': () => import(/* webpackChunkName: "desktop/components/formelements/treeselect-multiple" */ '@desktop/components/formelements/TreeSelectMultiple'),
    'csp-from-group-tree-select-multiple': () => import('@desktop/components/formelements/FormGroupTreeSelectMultiple.vue'),
    'csp-appraiser-select': () => import('@desktop/components/formelements/AppraiserSelect.vue'),
    'csp-form-group-appraiser-select': () => import('@desktop/components/formelements/FormGroupAppraiserSelect.vue'),
    'csp-bank-bic-input': () => import('@desktop/components/formelements/BankBicInput.vue'),
    'csp-form-group-bank-bic-input': () => import('@desktop/components/formelements/FormGroupBankBicInput.vue'),
    'csp-record-file-list': () => import('@desktop/components/record/RecordFileList'),
    'csp-note-calendar': () => import(/* webpackChunkName: "desktop/components/notes/noteCalendar" */ '@desktop/components/notes/NoteCalendar'),
    'csp-desktop-sidebar': () => import('@desktop/components/Sidebar.vue'),
    'csp-desktop-sidebar-support': () => import('@desktop/components/SidebarSupportButton.vue'),
    'csp-desktop-record': () => import('@desktop/components/Record.vue'),
    'csp-desktop-info-card': () => import('@desktop/components/helpers/InfoCard.vue'),
    'csp-desktop-info-card-element': () => import('@desktop/components/helpers/InfoCardElement.vue'),
    'csp-klippa-info-card-element': () => import(/* webpackChunkName: "desktop/components/record/klippa/klippa-info-card-element" */ '@desktop/components/record/klippa/KlippaInfoCardElement.vue'),
    'csp-responsible-users': () => import('@desktop/components/ResponsibleUsers.vue'),
    'csp-note-user-detail': () => import('@desktop/components/record/notes/NoteUserDetail.vue'),
    'csp-note-table-dates': () => import('@desktop/components/record/notes/NoteTableDates.vue'),
    'csp-plain-html': () => import('@desktop/components/PlainHTML.vue'),
    'csp-user-roles': () => import('@desktop/components/user/UserRoles.vue'),
    'csp-retroactive-changes-modal': RetroactiveChangesModal,

    // App components
    'csp-foldable-base': FoldableBase,
    'csp-record-accident-contract-field': () => import(/* webpackChunkName: "desktop/components/record/detail/accident/contract-field" */ '@desktop/components/record/detail/accident/ContractField'),
    'csp-record-damage-image-select': () => import(/* webpackChunkName: "components/record/record-damage-image-select" */ '@components/record/RecordDamageImageSelect'),
    'csp-record-file-drop': () => import(/* webpackChunkName: "desktop/components/record/record-file-drop" */ '@desktop/components/record/RecordFileDrop'),
    'csp-record-table-file-drop': () => import(/* webpackChunkName: "desktop/components/record/list/record-table-file-drop" */ '@desktop/components/record/list/RecordTableFileDrop'),
    'csp-record-table-firm-name-with-tooltip': RecordTableFirmNameWithTooltip,
    'csp-record-table-reference-number-with-hint': RecordTableReferenceNumberWithHint,
    'csp-record-table-row': RecordTableRow,
    'csp-record-header': () => import(/* webpackChunkName: "desktop/components/record/detail/record-header" */ '@desktop/components/record/detail/RecordHeader'),
    'csp-record-cost-unit-table': () => import(/* webpackChunkName: "desktop/components/record/detail/record-cost-unit-table" */ '@desktop/components/record/detail/costunit/CostUnitTable'),
    'csp-form-group-select-insurance-policy-parent': FormGroupSelectInsurancePolicyParent,
    'csp-record-customer-vehicle-info': RecordCustomerVehicleInfo,

    // Views
    'csp-customer-template-detail': () => import('@desktop/views/customerTemplate/CustomerTemplateDetail.vue'),
    'csp-customer-template-create': () => import('@desktop/views/customerTemplate/CustomerTemplateCreate.vue'),
    'csp-firm-appraiser-assignment': () => import(/* webpackChunkName: "desktop/views/firm/treeselect" */ '@desktop/views/firm/Appraiser'),
    'csp-firmgroup-firmlevels': () => import(/* webpackChunkName: "desktop/views/firmgroup/firmlevels" */ '@desktop/views/firmgroup/Firmlevels'),
    'csp-receipt-generate': () => import('@desktop/views/receipt/ReceiptGenerate.vue'),
    'csp-receipt-list-export-buttons': () => import('@desktop/views/receipt/ReceiptListExportButtons.vue'),
    'csp-record-detail-accident': () => import(/* webpackChunkName: "desktop/views/record/detail/accident" */ '@desktop/views/record/detail/Accident'),
    'csp-record-detail-documents-modal': () => import(/* webpackChunkName: "desktop/views/record/detail/documents-modal" */ '@desktop/views/record/detail/DocumentsModal'),
    'csp-record-document-split-modal': () => import(/* webpackChunkName: "desktop/components/record/document/DocumentSplitModal" */ '@desktop/components/record/document/DocumentSplitModal'),
    'csp-record-file-signature-modal': () => import('@desktop/views/record/detail/FileSignatureModal'),
    'csp-record-move-to-damage-service-provider': () => import('@desktop/views/record/MoveToDamageServiceProvider'),
    'csp-record-move-to-firm': () => import(/* webpackChunkName: "desktop/views/record/move-to-firm" */ '@desktop/views/record/MoveToFirm'),
    'csp-analytic': () => import(/* webpackChunkName: "desktop/views/analytic" */ '@desktop/views/Analytic'),
    'csp-report': () => import(/* webpackChunkName: "desktop/views/report" */ '@desktop/views/Report'),
    'csp-announcements': () => import(/* webpackChunkName: "desktop/views/report" */ '@desktop/views/Announcements'),
    'csp-external-upload': () => import(/* webpackChunkName: "desktop/views/report" */ '@desktop/views/external/Upload'),
    'csp-manuals': () => import(/* webpackChunkName: "desktop/views/manuals" */ '@desktop/views/Manuals'),
    'csp-link-for-record-creation-by-customer': () => import(/* webpackChunkName: "desktop/views/link-for-record-creation-by-customer" */ '@desktop/views/LinkForRecordCreationByCustomer'),
    'csp-record-list': () => import('@desktop/views/record/List.vue'),
    'csp-record-list-legacy': () => import('@desktop/views/record/ListLegacy.vue'),
    'csp-firm-list': () => import('@desktop/views/Firms.vue'),
    'csp-firm-archive': () => import('@desktop/views/FirmsArchive.vue'),
    'csp-user-list': () => import('@desktop/views/Users.vue'),
    'csp-inbox': () => import('@desktop/components/inbox/Inbox.vue'),
    'csp-user-create': () => import('@desktop/views/user/UserCreate.vue'),
    'csp-user-detail': () => import('@desktop/views/user/UserDetail.vue'),
    'csp-user-substitute': () => import('@desktop/views/user/UserSubstitute.vue'),
    'csp-user-credentials': () => import('@desktop/views/user/UserCredentials.vue'),
    'csp-marketingvisit-create': () => import('@desktop/views/marketingvisit/MarketingVisitCreate.vue'),
    'csp-marketingvisit-show': () => import('@desktop/views/marketingvisit/MarketingVisitShow.vue'),
    'csp-area-create': () => import('@desktop/views/area/AreaCreate.vue'),
    'csp-area-show': () => import('@desktop/views/area/AreaShow.vue'),
    'csp-announcement-list': () => import('@desktop/views/Announcement/AnnouncementList.vue'),
    'csp-insurance-create': () => import('@desktop/views/insurance/InsuranceCreate.vue'),
    'csp-insurance-show': () => import('@desktop/views/insurance/InsuranceShow.vue'),
    'csp-table': () => import('@desktop/views/Table.vue'),
    'csp-record-table': () => import('@desktop/views/record/RecordTable.vue'),
    'csp-record-creation': () => import('@desktop/views/record/Create.vue'),
    'csp-record-creation-success': () => import('@desktop/views/record/CreateSuccess.vue'),
    'csp-sap-payments': () => import('@desktop/views/record/SAPPayments.vue'),
    'csp-email-detail-modal': () => import(/* webpackChunkName: "desktop/components/digital-mailbox/email-detail-modal" */ '@desktop/components/digital-mailbox/EmailDetailModal.vue'),
};
